import { useEffect, useMemo, useState } from "react";
import PopupFooter from ".";
import bgHeader from "../../../../../assets/images/Mini-Game/header-mission.png";
import { Pagination, Table } from "antd";
import { useTranslation } from "react-i18next";
import bgButtonActive from "../../../../../assets/images/Mini-Game/bg-tab-active-popup.png";
import bgButton from "../../../../../assets/images/Mini-Game/bg-tab-popup.png";
import iconLeft from "../../../../../assets/images/Mini-Game/arrow-left.svg";
import bgButtonAction from "../../../../../assets/images/Mini-Game/bg-button.png";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import {
  getDataAwardListMiniGame,
  getDataHistoryMiniGame,
  getDataListWinnerMiniGame,
  getDataListWinnerPastMiniGame,
} from "../../../../../Redux/futures/mini-game/action";
import { getDataApi } from "../../../../../config/service";
import API_PATH from "../../../../../config/API_PATH";
import {
  curStateAccount,
  curStateMiniGame,
} from "../../../../../Redux/selector";
import moment from "moment/moment";
import _ from "lodash";

const LIMIT_DATA = 10;
export default function PopupWinner({
  isShowPopupHistory,
  setIsShowPopupHistory,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isLoader, setIsLoader] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showDetail, setShowDetail] = useState(false);
  const [tabActive, setTabActive] = useState(0);
  const [mergedData, setMergedData] = useState([]);
  const [mergedDataHistory, setMergedDataHistory] = useState([]);
  const [bestWinnerByCycle, setBestWinnerByCycle] = useState([]);
  const [cycleTime, setCycleTime] = useState("");
  const selectorAccount = useSelector(curStateAccount);
  const {
    dataListWinnerMini = [],
    dataListWinnerPastMini = [],
    dataHistoryMini = [],
    dataAwardListMini = [],
  } = useSelector(curStateMiniGame);

  const specialPrize = useMemo(() => {
    return dataAwardListMini?.find((item) => +item.rank === 1);
  }, [dataAwardListMini]);

  const isLogin = !!selectorAccount?.userInfo;

  const dataTab = [
    {
      id: 0,
      content: t("mini_game.pop_up_winner.current"),
    },
    {
      id: 1,
      content: t("mini_game.pop_up_winner.past"),
    },
    ...(isLogin
      ? [
          {
            id: 2,
            content: t("mini_game.pop_up_winner.your_prizes"),
          },
        ]
      : []), // hien thi tab your prizes khi da dang nhap
  ];
  const dataMiniGame = useSelector(curStateMiniGame);
  useEffect(() => {
    if (_.isEmpty(dataMiniGame.dataAwardListMini)) {
      dispatch(getDataAwardListMiniGame());
    }
  }, []);

  useEffect(() => {
    setIsLoader(true);
    if (tabActive === 1) {
      dispatch(
        getDataHistoryMiniGame({
          page: currentPage,
          limit: LIMIT_DATA,
        })
      );
    } else if (tabActive === 2) {
      dispatch(
        getDataListWinnerMiniGame({
          my_winner: 1,
        })
      );
    } else {
      dispatch(
        getDataListWinnerMiniGame({
          my_winner: 0,
        })
      );
    }
    setTimeout(() => {
      setIsLoader(false);
    }, [400]);
    return () => {
      clearTimeout();
    };
  }, [tabActive, currentPage]);

  useEffect(() => {
    const data = dataListWinnerMini?.map((item) => {
      if (tabActive === 2) {
        return {
          ...item,
          cycle: `${moment(item.start_time).format("DD/MM/YYYY")} - ${moment(
            item.end_time
          ).format("DD/MM/YYYY")}`,
        };
      }
      const prize = dataAwardListMini?.find(
        (prize) => +prize.id === +item.award_id
      );
      return {
        ...item,
        image: prize ? prize.image : null,
      };
    });

    if (tabActive === 2) {
      return setMergedData(data);
    }
    const groupedByMinigameId = _.groupBy(data, (item) => item.minigame_id);
    let newData = [];
    for (const key in groupedByMinigameId) {
      const formatData = groupedByMinigameId[key].sort((a, b) =>
        moment(b.take_time).diff(moment(a.take_time))
      );
      newData = [...newData, ...formatData];
    }

    newData = newData.map((item = {}) => {
      return {
        ...item,
        cycle: `${moment(item.start_time).format("DD/MM/YYYY")} - ${moment(
          item.end_time
        ).format("DD/MM/YYYY")}`,
      };
    });

    setMergedData(newData);
  }, [dataListWinnerMini, dataAwardListMini, tabActive]);

  useEffect(() => {
    const sortedData = [...dataListWinnerPastMini].sort(
      (a, b) => +a.award_id - +b.award_id
    );
    const data = sortedData.map((item) => {
      const prize = dataAwardListMini?.find(
        (prize) => prize.id === +item.award_id
      );
      return {
        ...item,
        image: item?.image || prize?.image || null,
      };
    });

    const formatData = data.sort((a, b) => Number(a.rank) - Number(b.rank));
    let groupedByAwardId = _.groupBy(formatData, (item) => item.award_id);
    if (showDetail && tabActive === 1) {
      groupedByAwardId = _.groupBy(formatData, (item) => item.rank);
    }

    let newData = [];
    for (const key in groupedByAwardId) {
      const formatData = groupedByAwardId[key].sort((a, b) =>
        moment(a.take_time).diff(moment(b.take_time))
      );
      newData = [...newData, ...formatData];
    }

    setMergedDataHistory(newData);
  }, [dataListWinnerPastMini, dataAwardListMini]);

  useEffect(() => {
    const fetchBestWinners = async () => {
      const results = await Promise.all(
        dataHistoryMini.map(async (cycle) => {
          const response = await getDataApi(
            `${API_PATH.miniGameLisWinner}?my_winner=0&minigame_id=${cycle.id}`
          );

          if (!response?.data?.length) return null;
          const dataApi = response.data || [];

          const best = dataApi.find((item) => +item.rank === 1) || {};

          // Find image from dataPrizeCollection based on award_id
          const prize = dataAwardListMini?.find(
            (p) => +p.id === +best.award_id
          );

          return {
            id: cycle.id,
            cycle: `${moment(cycle.start_time).format("DD/MM/YYYY")} - ${moment(
              cycle.end_time
            ).format("DD/MM/YYYY")}`,
            name: best.name,
            isdn: best.isdn,
            image: cycle?.image || prize?.image || best?.image || null,
          };
        })
      );

      setBestWinnerByCycle(results.filter(Boolean));
    };

    if (tabActive === 1) {
      fetchBestWinners();
    }
  }, [tabActive, dataHistoryMini, dataAwardListMini]);
  // console.log(tabActive);

  const highlightRow = (record) => {
    return +record.its_me === 1 ? "highlight-row" : "";
  };

  return (
    <ContainerPopupWin className="popup-minigame__2025 popup-mini-activity-his">
      <PopupFooter
        isOpen={isShowPopupHistory}
        onClose={() => setIsShowPopupHistory(false)}
        className={"container-popup-winner-mini"}
      >
        <>
          <div className="header-mini-popup-rule">
            <img src={bgHeader} alt="" className="img-rule-mini" />
            <div className="content-rule-mini">
              {t("mini_game.pop_up_winner.winner")}
            </div>
          </div>

          <div className="mini-tab-popup">
            {dataTab.map((item) => (
              <div
                key={item.id}
                className={`position-relative tab-mini-popup ${
                  item.id === tabActive ? "tab-popup-active" : ""
                }`}
                onClick={() => {
                  setTabActive(item.id);
                  setShowDetail(false);
                  setCycleTime("");
                }}
              >
                <img
                  src={item.id === tabActive ? bgButtonActive : bgButton}
                  alt=""
                  style={{ minHeight: "50px" }}
                />
                <div className="tab-popup__content">{item.content}</div>
              </div>
            ))}
          </div>

          {showDetail && tabActive === 1 && (
            <Div>
              <div
                className="container-bg-action scale-hover-item"
                onClick={() => {
                  setShowDetail(false);
                  setCycleTime({
                    start_time: "",
                    end_time: "",
                  });
                }}
              >
                <img
                  src={bgButtonAction}
                  alt=""
                  className="bg-btn-header-mini"
                />
                <img src={iconLeft} alt="" className="bg-action-thingyan" />
              </div>

              <p>
                <i>
                  <strong>{t("mini_game.pop_up_winner.cycle")}: </strong>
                  {cycleTime}
                </i>
              </p>
            </Div>
          )}

          {showDetail && tabActive === 1 ? (
            <Table
              className="table-winner"
              dataSource={mergedDataHistory}
              loading={isLoader}
              pagination={false}
              scroll={{
                y: 365,
              }}
              rowClassName={highlightRow}
              rowHoverable
              style={{
                cursor: "pointer",
              }}
            >
              <Table.Column
                align="center"
                title={t("event_thingyan.pop_up.prize")}
                // dataIndex="image"
                key="image"
                render={(data) => {
                  return (
                    <div
                      className="column-prize w-auto h-auto"
                      style={{
                        // minHeight: `${isLoader ? "100px" : ""}`,
                        textAlign: "center",
                      }}
                    >
                      <img
                        src={data?.image}
                        alt="prize"
                        width={40}
                        height={40}
                        style={{ margin: "0 auto" }}
                      />
                      <p className="prize-name">{data.name}</p>
                    </div>
                  );
                }}
              />
              <Table.Column
                title={t("event_thingyan.pop_up.time")}
                dataIndex="take_time"
                key="time"
                render={(data) => {
                  return (
                    <div>
                      {data ? moment(data).format("DD/MM/YYYY HH:mm:ss") : null}
                    </div>
                  );
                }}
              />
              <Table.Column
                title={t("event_thingyan.pop_up.isdn")}
                dataIndex="isdn"
                key="isdn"
              />
            </Table>
          ) : tabActive === 1 ? (
            <Table
              className="table-winner"
              dataSource={bestWinnerByCycle}
              loading={isLoader}
              pagination={false}
              scroll={{
                y: 365,
              }}
              rowClassName={highlightRow}
              rowHoverable
              onRow={(record) => {
                if (record) {
                  return {
                    onClick: () => {
                      setShowDetail(true);
                      setCycleTime(record.cycle);
                      dispatch(
                        getDataListWinnerPastMiniGame({
                          my_winner: 0,
                          minigame_id: record.id,
                        })
                      );
                    },
                  };
                } else {
                  return {
                    onClick: () => {
                      setShowDetail(false);
                      setCycleTime("");
                    },
                  };
                }
              }}
              style={{
                cursor: "pointer",
              }}
            >
              <Table.Column
                title={t("mini_game.pop_up_winner.cycle")}
                key="cycle"
                render={(data) => {
                  return <i>{data?.cycle}</i>;
                }}
              />
              <Table.Column
                title={t("mini_game.pop_up_winner.best_prize")}
                // dataIndex="image"
                key="image"
                align="center"
                render={(data) => {
                  return (
                    <div
                      className="column-prize w-auto h-auto"
                      style={{
                        // minHeight: `${isLoader ? "100px" : ""}`,
                        textAlign: "center",
                      }}
                    >
                      <img
                        src={data?.image}
                        alt="prize"
                        width={40}
                        height={40}
                        style={{ margin: "0 auto" }}
                      />
                      <p className="prize-name">{data?.name}</p>
                    </div>
                  );
                }}
              />
              <Table.Column
                title={t("event_thingyan.pop_up.isdn")}
                dataIndex="isdn"
                key="isdn"
              />
            </Table>
          ) : (
            <Table
              className="table-winner"
              dataSource={mergedData}
              loading={isLoader}
              pagination={false}
              scroll={{
                y: 365,
              }}
              rowClassName={highlightRow}
              rowHoverable
              style={{
                cursor: "pointer",
              }}
            >
              <Table.Column
                title={t("event_thingyan.pop_up.prize")}
                // dataIndex="image"
                key="image"
                align="center"
                render={(data) => {
                  return (
                    <div
                      className="column-prize w-auto h-auto"
                      style={{
                        // minHeight: `${isLoader ? "100px" : ""}`,
                        textAlign: "center",
                      }}
                    >
                      <img
                        src={data?.image}
                        alt="prize"
                        width={40}
                        height={40}
                        style={{ margin: "0 auto" }}
                      />
                      <p className="prize-name">{data.name}</p>
                    </div>
                  );
                }}
              />
              <Table.Column
                title={t("event_thingyan.pop_up.time")}
                dataIndex="take_time"
                key="time"
                render={(data) => {
                  return (
                    <div>
                      {data ? moment(data).format("DD/MM/YYYY HH:mm:ss") : null}
                    </div>
                  );
                }}
              />
              {tabActive === 0 ? (
                <Table.Column
                  title={t("event_thingyan.pop_up.isdn")}
                  dataIndex="isdn"
                  key="isdn"
                />
              ) : (
                <Table.Column title={"Cycle"} dataIndex="cycle" key="cycle" />
              )}
            </Table>
          )}
          {tabActive === 1 && bestWinnerByCycle?.length > LIMIT_DATA ? (
            <div className="pagination-popup-his__mini-game">
              <Pagination
                current={currentPage}
                pageSize={10}
                total={bestWinnerByCycle?.length}
                onChange={(page) => setCurrentPage(page)}
                showSizeChanger={false}
                itemRender={(page, type, originalElement) => {
                  if (type === "prev") {
                    return (
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                        className="action-table-mini-game"
                      >
                        ←
                        {/* ←{" "}
                      <span className="action-table-mini-game-content">
                        Previous
                      </span> */}
                      </span>
                    );
                  }
                  if (type === "next") {
                    return (
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                        className="action-table-mini-game"
                      >
                        {/* <span className="action-table-mini-game-content">
                        Next
                      </span>{" "} */}
                        →
                      </span>
                    );
                  }
                  return originalElement;
                }}
              />
            </div>
          ) : null}

          <div className="mini-content-footer">
            {`${t("mini_game.pop_up_winner.footer").replace(
              "XXX",
              specialPrize?.name || ""
            )} ${t("mini_game.pop_up_winner.footer_trailing")}`}
          </div>
        </>
      </PopupFooter>
    </ContainerPopupWin>
  );
}

const ContainerPopupWin = styled.div`
  @media (max-width: 576px) {
    .img-rule-mini {
      width: calc(100% - 20px) !important;
    }
  }
`;

const Div = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 12px 18px 16px;
  margin-top: 0;
  position: relative;
  z-index: 2;

  p {
    margin: 0 auto;
  }

  .container-bg-action {
    position: relative;
    width: 52px;
    height: 52px;
    cursor: pointer;
  }

  .bg-action-thingyan {
    position: absolute;
    top: 50%;
    left: 50%;
    /* width: 30px;
      height: 30px; */
    transform: translate(-50%, -50%);
  }

  @media (max-width: 768px) {
    .bg-btn-header-mini {
    }

    .container-bg-action {
      height: 45px;
      width: 45px;
    }

    .container-bg-action:first-child .bg-action-thingyan {
      width: 19px;
    }

    .container-bg-action:nth-child(2) .bg-action-thingyan {
      width: 11px;
    }

    .container-bg-action:last-child .bg-action-thingyan {
      width: 25px;
    }

    .icon-bid-event {
      width: 45px;
    }

    .icon-bid-event {
      margin-bottom: 0 !important;
    }
  }

  @media (max-width: 576px) {
    .event-bid {
      height: 34px;
      width: 87px;

      .icon-bid-event {
        height: 34px;
        margin-left: -10px;
      }
    }

    .detail-event {
      gap: 8px;
    }

    .container-bg-action {
      width: 34px;
      height: 34px;
      /* height: 48px; */
    }

    .bg-action-thingyan {
      width: 20px;
      height: 20px;
    }
  }
`;
